import {Controller} from "@hotwired/stimulus"
import { Calendar } from "fullcalendar"
import multiMonthPlugin from '@fullcalendar/multimonth'
import dayGridPlugin from '@fullcalendar/daygrid';
import moment from "moment"

export default class extends Controller {
  static targets = ["calendar", "event", "tip", "selector", "user"];

  static values = {
    height: { type: Number, default: 1000 },
    view: { type: String, default: 'month' },
    editable: { type: Boolean, default: false },
    holidays: { type: Array, default: [] }
  }
  connect() {
    const that = this;
    const events = [];
    let view = "dayGridMonth";
    let start = new Date();
    let tip;
    let today_text = 'Сегодня';
    if (this.hasTipTarget) {
      tip = that.tipTarget;
    }
    Array.from(that.eventTargets).forEach((event) => {
      let text = "black";
      let color = "#a1a1aa";
      if (event.dataset.kind == "annual_leave") {
        color = "#fed7aa";
        if (event.dataset.status == "agreed") {
          color = "#fb923c";
          text = "white";
        }
      }
      if (event.dataset.kind == "time_off") {
        color = "#c7d2fe";
        if (event.dataset.status == "agreed") {
          color = "#6366f1";
          text = "white";
        }
      }

      if (event.dataset.kind == "sick") {
        color = "#dc2626";
        text = "white";
      }
      events.push(
        { start: event.dataset.since, end: event.dataset.end, title: event.dataset.comment,
          backgroundColor: color, borderColor: color, description: event.dataset.comment,
          textColor: text, state: event.dataset.state,  until: event.dataset.until, id: event.dataset.id,
          position: event.dataset.position
        }
      );
    });
    if(that.viewValue == "multi"){
      view = "multiMonthYear";
      today_text = "Текущий год"
    }

    if(that.viewValue == "week"){
      view = "timeGridWeek";
      today_text = "Текущая неделя"
    }
    const calendar = new Calendar(that.calendarTarget, {
      locale: {
        code: 'ru',
        week: {
          dow: 1,
          doy: 4,
        },
        buttonText: {
          prev: 'Пред',
          next: 'След',
          today: today_text,
          year: 'Год',
          month: 'Месяц',
          week: 'Неделя',
          day: 'День',
          list: 'Повестка дня',
        },
        weekText: 'Нед',
        allDayText: 'Весь день',
        moreLinkText(n) {
          return '+ ещё ' + n;
        },
        noEventsText: 'Нет событий для отображения',
      },
      businessHours: {
        daysOfWeek: [ 1, 2, 3, 4, 5 ],

        startTime: '09:00',
        endTime: '18:00',
      },
      slotMinTime: '07:00',
      slotMaxTime: '23:00',
      plugins: [multiMonthPlugin, dayGridPlugin],
      dayMaxEventRows: true,
      initialView: view,
      multiMonthMinWidth: 400,
      visibleRange: {
        start: start.toISOString().split('T')[0],
      },
      height: that.heightValue,
      contentHeight:"auto",
      fixedWeekCount: false,
      showNonCurrentDates: true,
      events: events,
      eventDidMount: function(info) {
        if (that.hasSelectorTarget) {
          let val = that.selectorTarget.value;
          if (!(val == info.event.extendedProps.position || val == "unknown")) {
            info.el.style.display = "none";
          }
        }
        if (that.hasUserTarget) {
          let val = that.userTarget.value;
          if (!(val == info.event.title || !val)) {
            info.el.style.display = "none";
          }
        }
        const eventEndDate = new Date(info.event.end);
        const now = new Date();

        if (that.viewValue == "multi") {
          info.el.classList.add("small-event");
        }

        if (that.editableValue) {
          info.el.style.cursor = "pointer";
        }

        if (eventEndDate < now) {
          info.el.style.opacity = 0.3;
        }
      },
      dayCellClassNames: function(arg) {
        let is_holiday = that.fetchHolidayData(arg.date);
        if (is_holiday) {
          return ['is-holiday'];
        }
        return [];
      },
      dayCellDidMount: function(info) {
        let date = moment(info.date).add(3, 'hours');
        date = date.toISOString().split('T')[0];

        fetch("https://isdayoff.ru/" + date).then(response => response.json()).then(result => result === "1" ? info.el.classList.add("is-holiday") : "");
      },
      eventMouseEnter: function(info) {
        if (that.hasTipTarget) {
          let event = info.event;
          let jsEvent = info.jsEvent;

          tip.innerHTML = event.title + ": " + event.start.toLocaleDateString() + " - " + event.extendedProps.until + " (" + event.extendedProps.state + ")";
          tip.style.left = jsEvent.pageX + 5 + "px";
          tip.style.top = jsEvent.pageY + 5 + "px";
          tip.classList.remove("hidden");
        }
      },
      eventMouseLeave: function(info) {
        if (that.hasTipTarget) {
          tip.classList.add("hidden");
        }
      },
      eventClick: function(info) {
        if (that.editableValue && info.event && info.event.id) {
          const basePath = info.event.id;

          const currentBrowserUrl = window.location.href;

          const targetUrl = new URL(basePath, window.location.origin);
          targetUrl.searchParams.set('back', currentBrowserUrl);
          const editUrl = targetUrl.pathname + targetUrl.search;

          if (editUrl.startsWith('/')) {
            if (window.Turbo) {
              window.Turbo.visit(editUrl, { frame: "remote_modal" });
            } else {
              const frame = document.getElementById("remote_modal");
              if (frame) frame.src = editUrl;
            }
          }
        }
      }
    })

    this.calendar = calendar
    this.calendar.render()
  }

  fetchHolidayData(date) {
    const last_year = "11111111001100000110000011000001100000110000011000001100000110000011000001100000110000011000001100000110000011000001100011110001111000001100000110000011000001100011110000011000001100000110000011000001100000110000011000001100000110000011000001100000110000011000001100000110000011000001100000110000011000000111000110000011000001100000110000011000001100000110000011001"
    const year = "11111111111000001100000110000011000001100000110000011100001100000111000011000001100000110000011000001100000110000011000011100000111000011000001100000110000011000011100000110000011000001100000110000011000001100000110000011000001100000110000011000001100000110000011000001100000110000011000001100000110000011001001100000110000011000001100000110000011000001100000110001"
    let index = this.daysIntoYear(date)
    let result = last_year[index - 1];
    if (date.getFullYear() == 2026) {
      result = year[index - 1];
    }

    return Boolean(parseInt(result));
  }

  daysIntoYear(date){
    return (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
  }

  resetAndRefresh(event) {
    const changedInput = event.target

    if (this.hasSelectorTarget && changedInput === this.selectorTarget && this.hasUserTarget) {
      this.userTarget.value = ""
    }

    if (this.hasUserTarget && changedInput === this.userTarget && this.hasSelectorTarget) {
      this.selectorTarget.value = "unknown"
    }

    const url = new URL(window.location.href)

    const kind = this.hasSelectorTarget ? this.selectorTarget.value : ""
    const user = this.hasUserTarget ? this.userTarget.value : ""

    if (kind && kind !== "unknown") { url.searchParams.set('kind', kind) } else { url.searchParams.delete('kind') }
    if (user) { url.searchParams.set('user', user) } else { url.searchParams.delete('user') }

    window.history.replaceState({}, '', url.toString())

    this.calendar.destroy()
    this.calendar.render()
  }

}